import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import {
  Text,
  TextType,
  Button,
  ButtonType,
  ProfileIcon,
  Icon,
} from '@hum/ui-library';
import clsx from 'clsx';
import { useSession } from '@hum/api/src/Session/useSession';

type TopbarProfileMenuProps = {
  hideSettings?: boolean;
  showAuthSection?: boolean;
};

export default function TopbarProfileMenu({
  hideSettings = false,
  showAuthSection,
}: TopbarProfileMenuProps) {
  const { user } = useSession();

  const ProfileMenu = () => (
    <>
      <Menu
        as="div"
        className="relative hidden lg:block"
        data-testid="user:open-more-menu-btn"
      >
        <Menu.Button className="cursor-pointer">
          <ProfileIcon>{user?.firstName.charAt(0).toUpperCase()}</ProfileIcon>
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={clsx(
              'absolute -left-[90px] z-[1000] bg-gray-600 shadow-default rounded-default',
              { '-bottom-[85px]': !hideSettings }
            )}
          >
            {!hideSettings && (
              <Menu.Item>
                <Button
                  type={ButtonType.QUIET}
                  onClick={() =>
                    // eslint-disable-next-line no-process-env
                    (window.location.href = `${process.env.V2_BASE_URL}/?settings=open`)
                  }
                  className="w-full py-2"
                >
                  <Text type={TextType.BODY_M} className="cursor-pointer">
                    Settings
                  </Text>
                </Button>
              </Menu.Item>
            )}

            <Menu.Item>
              <Button
                type={ButtonType.QUIET}
                onClick={() =>
                  // eslint-disable-next-line no-process-env
                  window.location.replace(`${process.env.V2_BASE_URL}/logout`)
                }
                className="w-full py-2"
              >
                <Text type={TextType.BODY_M} className="cursor-pointer">
                  Logout
                </Text>
              </Button>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
      <ProfileIcon className="block lg:hidden">
        {user?.firstName.charAt(0).toUpperCase()}
      </ProfileIcon>
    </>
  );

  if (!user) return <></>;

  if (showAuthSection) {
    return (
      <div className="flex items-center justify-end">
        <div className="items-center hidden mr-4 md:flex">
          <Icon.Padlock className="mr-1 fill-transparent" width="16" />
          <Text type={TextType.BODY_S} subdued>
            256-Bit Bank-Level Encryption
          </Text>
        </div>
        <ProfileMenu />
      </div>
    );
  }

  return <ProfileMenu />;
}
